import React from "react";
import IMAGEM from "components/imagem";
import {formatImage} from "components/formatos";
import "./style.css";

const Promocao = ({ promocao, index }) => {
    const imageUrl = formatImage(promocao?.url_foto || promocao?.imagem);
    
    return (
        <div key={index} className="promocao-container promocao-card loja-promocao-card">
            {imageUrl ? (
                <IMAGEM
                    participantes={true}
                    src={imageUrl}
                    className="promocao-img"
                />
            ) : (
                <div className="promocao-placeholder">
                    <i className="fas fa-tag"></i>
                </div>
            )}
        </div>    
    );
};

export default Promocao;